const CHAVES_MENSAGEM = ["erro", "error", "mensagem", "message", "detail", "detalhe"] as const;
const CHAVES_ANINHADAS = ["data", "payload", "response", "resposta", "cause", "causa"] as const;

function ehRegistro(valor: unknown): valor is Record<string, unknown> {
  return typeof valor === "object" && valor !== null;
}

function textoUtil(valor: unknown): string {
  if (typeof valor !== "string") return "";
  const texto = valor.trim();
  if (!texto || /^\d{3}$/.test(texto) || /^HTTP\s*\d+/i.test(texto)) return "";
  if (/^<!doctype|^<html[\s>]/i.test(texto)) return "";
  return texto;
}

export function extrairMensagemErroApi(valor: unknown, fallback = ""): string {
  const visitados = new Set<unknown>();

  function extrair(atual: unknown, profundidade: number): string {
    if (profundidade > 5 || atual == null || visitados.has(atual)) return "";
    const direta = textoUtil(atual);
    if (direta) return direta;
    if (atual instanceof Error) {
      visitados.add(atual);
      const erroComRetorno = atual as Error & {
        payload?: unknown;
        response?: unknown;
        data?: unknown;
        cause?: unknown;
      };
      for (const retorno of [erroComRetorno.payload, erroComRetorno.response, erroComRetorno.data, erroComRetorno.cause]) {
        const mensagemRetorno = extrair(retorno, profundidade + 1);
        if (mensagemRetorno) return mensagemRetorno;
      }
      const mensagem = textoUtil(atual.message);
      if (mensagem) return mensagem;
      return "";
    }
    if (Array.isArray(atual)) {
      visitados.add(atual);
      for (const item of atual) {
        const mensagem = extrair(item, profundidade + 1);
        if (mensagem) return mensagem;
      }
      return "";
    }
    if (!ehRegistro(atual)) return "";
    visitados.add(atual);

    for (const chave of CHAVES_MENSAGEM) {
      const mensagem = extrair(atual[chave], profundidade + 1);
      if (mensagem) return mensagem;
    }
    for (const chave of ["erros", "errors", "violations", "validacoes"]) {
      const mensagem = extrair(atual[chave], profundidade + 1);
      if (mensagem) return mensagem;
    }
    for (const chave of CHAVES_ANINHADAS) {
      const mensagem = extrair(atual[chave], profundidade + 1);
      if (mensagem) return mensagem;
    }
    return "";
  }

  return extrair(valor, 0) || fallback;
}
